export const validateAssetID = (assetId) => {
  let pattern = /^[A-Za-z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]+$/;
  return assetId && pattern.test(assetId);
};
